import { CurrencySelect } from "../../ContaInternacional/components/CurrencySelect";

import { formatCrossborderAmount, getCrossborderCurrencySymbol } from "../constants";

import { PaymentRouteChips } from "./PaymentRouteChips";



export const CrossborderAmountSection = ({

  title,

  amountInputId,

  amount,

  onAmountChange,

  amountCurrencyId,

  amountCurrencyOptions,

  onAmountCurrencyChange,

  showCurrencySelect = false,

  limits,

  originRailId,

  destinationRailId,

  fromCurrency,

  toCurrency,

  routePreview,

}) => {

  const symbol = getCrossborderCurrencySymbol(amountCurrencyId);

  const showRoute = routePreview && routePreview !== "—";

  const showCurrency =

    showCurrencySelect && amountCurrencyOptions?.length > 1;



  return (

    <section className="relative space-y-2 overflow-visible">

      <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1">

        <label htmlFor={amountInputId} className="text-xs font-medium text-gray-500">

          {title}

        </label>

        {showRoute && (

          <div className="flex shrink-0 items-center">

            <PaymentRouteChips

              originRailId={originRailId}

              destinationRailId={destinationRailId}

              fromCurrency={fromCurrency}

              toCurrency={toCurrency}

              fixedWidth={false}

            />

            <span className="sr-only">{routePreview}</span>

          </div>

        )}

      </div>



      <div className="flex items-stretch gap-2">

        {showCurrency && (

          <div className="relative z-[1] w-28 shrink-0 overflow-visible sm:w-32">

            <CurrencySelect

              id={`${amountInputId}-currency`}

              value={amountCurrencyId}

              onChange={onAmountCurrencyChange}

              options={amountCurrencyOptions}

            />

          </div>

        )}



        <div className="relative min-w-0 flex-1">

          <span

            className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base font-semibold text-gray-400"

            aria-hidden

          >

            {symbol}

          </span>

          <input

            id={amountInputId}

            type="text"

            inputMode="decimal"

            placeholder="0,00"

            value={amount}

            onChange={(e) => onAmountChange(e.target.value)}

            className="valut-input h-11 w-full rounded-xl border-gray-200 pl-10 pr-3 text-right text-xl font-bold tracking-tight text-brand-dark"

          />

        </div>

      </div>



      <p className="text-right text-xs text-gray-400">

        Mín. {formatCrossborderAmount(limits.min, amountCurrencyId)}

        <span className="mx-1.5" aria-hidden>

          ·

        </span>

        Máx. {formatCrossborderAmount(limits.max, amountCurrencyId)}

      </p>

    </section>

  );

};

